<template>
  <div id="relationship-rule" >

    <vs-table
      ref="table"
      noDataText="Nenhuma Régua de Relacionamento Cadastrada"
      :max-items="itemsPerPage"
      :data="relationshipRules"
      @search="searchFilter" 
      @sort="sortFilter" 
      :sst="true"
      search
    >

    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center ml-4">
          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
                text-lg font-medium text-base text-primary border border-solid border-primary" @click.stop="redirectToNew">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Adicionar Novo</span>
          </div>
        </div>


        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
                cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                relationshipRules.length - currentPage * itemsPerPage > 0
                ? currentPage * itemsPerPage
                : relationshipRules.length
              }} of {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <template slot="thead">
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th sort-key="is_real_time">Real Time?</vs-th>
        <vs-th sort-key="is_unique_dispatch">Disparo Unico?</vs-th>
        <vs-th sort-key="repeat_each_time">Quantidade de Repetições</vs-th>
        <vs-th sort-key="repeat_each_seasonality">Sazonalidade de Repetição</vs-th>
        <vs-th sort-key="rule_event_type_id">Tipo de Evento</vs-th>
        <vs-th>Categorias</vs-th>
        <vs-th sort-key="stops_at">Finaliza Em</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in relationshipRules">
            <vs-td :title="tr.name" :data="relationshipRules[indextr].name">
              <p>
                {{ tr.name }}
              </p>
            </vs-td>

            <vs-td :title="tr.is_real_time" :data="relationshipRules[indextr].is_real_time">
              <vs-chip :color="( tr.is_real_time ? 'success' : 'danger' )">
                {{ tr.is_real_time ? 'SIM' : 'NÃO' }}
              </vs-chip>
            </vs-td>

            <vs-td :title="tr.is_unique_dispatch" :data="relationshipRules[indextr].is_unique_dispatch">
              <vs-chip :color="( tr.is_unique_dispatch ? 'success' : 'danger' )">
                {{ tr.is_unique_dispatch ? 'SIM' : 'NÃO' }}
              </vs-chip>
            </vs-td>

            <vs-td :title="tr.repeat_each_time" :data="relationshipRules[indextr].repeat_each_time">
              <p>
                {{ tr.repeat_each_time }}
              </p>
            </vs-td>

            <vs-td :title="tr.repeat_each_seasonality" :data="relationshipRules[indextr].repeat_each_seasonality">
              <p>
                {{ tr.repeat_each_seasonality }}
              </p>
            </vs-td>
            
            <vs-td :title="tr.rule_event_type_id" :data="relationshipRules[indextr].rule_event_type_id">
              <p>
                {{ tr.ruleEventType !== null ? tr.ruleEventType.name : 'Não Possui' }}
              </p>
            </vs-td>
            <vs-td>
                <div v-for="(category, catIndex) in tr.categories" :key="`category-${catIndex}`">
                  <vs-chip :color="category.color_tag">
                    {{ category.name ? category.name : ''  }}
                  </vs-chip>
                </div>
            </vs-td>

            <vs-td :title="tr.stops_at" :data="relationshipRules[indextr].stops_at">
              <p>
                {{ tr.stops_at !== null ? tr.stops_at : 'Nunca' }}
              </p>
            </vs-td>

            <vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  v-if="canSee('update')"
                  @click.prevent="redirectToEdit(tr.id)"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                />

                <feather-icon
                  class="ml-2"
                  icon="TrashIcon"
                  v-if="canSee('delete')"
                  @click.prevent="openModalToDelete(tr)"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                />
              </vs-td>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup title="Remover Métrica Inteligente" :active.sync="openDeletePopUp" @close="openDeletePopUp = false" class="sizePopup">
      <p>Deseja realmente remover a régua de relacionamento ?</p>

      <div class="w-full d-flex justify-content-flex-end">
        <vs-button color="danger" @click.prevent="remove()">Remover</vs-button>
      </div>
    </vs-popup>
    <div class="mt-3 mr-12">
      <vs-pagination :total="totalPages" v-model="page" />
    </div>
  </div>
</template>
<script>
  import FormPopup from './FormPopup'
  import { hasPermission, formatRouteTenantPath } from '@/utils'
  import requests from '@/http/requests/relationshipRules'
  import moduleRelationshipRule from '@/store/relationshipRule/moduleRelationshipRule'

  export default {
    name: 'relationship-rules-list',
    components: {
      FormPopup,
    },
    data() {
      return {
        openDeletePopUp: false,
        selected: null,
        itemsPerPage: 4,
        currentPage: 1,
        search: "",
        page: 1,
        orderBy: {
          name: 'name',
          type: 'ASC'
        },
        relationshipRulesData: []
      }
    },
    watch: {
      'page'() {
        this.fetchRelationshipRules()
      },
      'itemsPerPage'() {
        this.page = 1
        this.fetchRelationshipRules()
      },
    },
    computed: {
      totalPages() {
        return this.$store.state.relationshipRule && this.$store.state.relationshipRule.relationshipRules.total_pages
            ? this.$store.state.relationshipRule.relationshipRules.total_pages
            : 0
      },
      queriedItems() {
        return this.$store.state.relationshipRule && this.$store.state.relationshipRule.relationshipRules.total_items
            ? this.$store.state.relationshipRule.relationshipRules.total_items
            : 0
      },
      currentPage() {
        if (this.isMounted) {
          return this.$refs.table.currentx;
        }

        return 0;
      },
      relationshipRules() {
        return this.$store.state.relationshipRule && this.$store.state.relationshipRule.relationshipRules
          ? this.$store.state.relationshipRule.relationshipRules.items : []
      }
    },
    async mounted() {
      await this.fetchRelationshipRules();
      this.isMounted = true;
      this.relationshipRulesData = this.$store.state.relationshipRule.relationshipRules.items
    },
    created () {
      if (!moduleRelationshipRule.isRegistered) {
        this.$store.registerModule('relationshipRule', moduleRelationshipRule)
        moduleRelationshipRule.isRegistered = true
      }
    },
    methods: {
      async fetchRelationshipRules() {
        await this.$store.dispatch("relationshipRule/fetchPaginated", {
          sortName: this.orderBy.name,
          page: this.page,
          itemsPerPage: this.itemsPerPage,
          type: this.orderBy.type,
          word: this.search
        })
      },
      async searchFilter(searchQuery) {
        this.search = searchQuery;
        this.fetchRelationshipRules();
      },
      async sortFilter(sortName) {
        if (sortName) {
          if (sortName !== this.orderBy.name) {
            this.orderBy.name = sortName;
            this.orderBy.type = 'ASC';
          } else if (this.orderBy.type !== "" && this.orderBy.type === "ASC") {
            this.orderBy.type = 'DESC';
          } else if (this.orderBy.name === sortName && this.orderBy.type === "DESC") {
            this.orderBy.name = 'name';
            this.orderBy.type = 'ASC';
          }
          this.fetchRelationshipRules();
        }
      },
      canSee(action) {
        return hasPermission(`relationship-rules-${action}`)
      },
      redirectToNew() {
        this.$router.push(formatRouteTenantPath('/messaging/relationship-rules/new'))
      },
      redirectToEdit(id) {
        this.$router.push(formatRouteTenantPath('/messaging/relationship-rules/' + id + '/edit'))
      },
      openModalToDelete(selected) {
        this.selected = selected;
        this.openDeletePopUp = true;
      },
      remove() {
        requests.delete(this.selected.id).then(() => {
          this.openDeletePopUp = false;
          this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'A régua foi removida com sucesso'
          });
          this.fetchRelationshipRules()
        }).catch((error) => {
          console.log(error)
        })
      },
    },
    beforeRouteLeave(to, from, next) {
      if (this.openDeletePopUp) {
          this.openDeletePopUp = false;
          setTimeout( ()=> {
          next();
          }, 2);
      }
      else {
          next();
      }
    }
  }
</script>
 
<style lang="scss">

#relationship-rule {
  .select {
    padding: 15px; 
    display:flex; 
    background: #fff;
    border-radius:10px; 
    text-align:center;
    flex-direction: column; 
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  .vs-table {
    border-collapse: separate;
    border-spacing: 0 0.7rem;
    padding: 0 1rem;

    tr{
      box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
      td{
        padding: 10px;
      }
    }
  }

  .vs-table--thead{
    th {
      
      padding-top: 0;
      padding-bottom: 0;

      .vs-table-text{
        text-transform: uppercase;
        font-weight: 600;
        
      }
    }
    tr{
      background: none;
      box-shadow: none;
    }
  }

  .vs-table--pagination {
    justify-content: center;
  }
}


</style>
